import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { registerTileCacheSW } from './lib/tileCache';
import './styles/globals.css';

// Service worker: persistent tile cache so the map gets faster with use.
registerTileCacheSW();

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
}
